<template>
    <div>
        <b-modal
            v-model="mostrarModal"
            :no-close-on-backdrop="true"
            @close="fecharModal()"
            :hide-header-close="true"
            :no-close-on-esc="true"
        >
            <div slot="modal-title">
                Itens - <b-badge variant="warning">{{ acao }}</b-badge>
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.produto.$error ? false: null"
                        invalid-feedback="O produto é obrigatório"
                    >
                        <label class="required">
                            Produto
                        </label>
                        <model-list-select
                            v-if="opcoes.produtosRm != null"
                            :list="opcoes.produtosRm"                    
                            option-text="nome"
                            option-value="idPrd"
                            v-model="produto"
                            @input="$v.produto.$touch()"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.natureza.$error ? false: null"
                        invalid-feedback="A natureza é obrigatória"
                    >
                        <label class="required">
                            Natureza
                        </label>
                        <model-list-select
                            v-if="opcoes.naturezasRm != null"
                            :list="opcoes.naturezasRm"                    
                            option-text="descricao"
                            option-value="codTB1FAT"
                            v-model="natureza"
                            @input="$v.natureza.$touch()"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.unidade.$error ? false: null"
                        invalid-feedback="A unidade é obrigatória"
                    >
                        <label class="required">
                            Unidade
                        </label>
                        <model-list-select
                            v-if="opcoes.unidadesRm != null"
                            :list="opcoes.unidadesRm"                    
                            option-text="descricao"
                            option-value="codUnd"
                            v-model="unidade"
                            @input="$v.unidade.$touch()"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="!temRateio">
                    <b-form-group
                        :state="$v.quantidade.$error ? false: null"
                        invalid-feedback="A quantidade é obrigatória"
                    >
                        <label class="required" for="quantidade">
                            Quantidade
                        </label>
                        <money
                            id="quantidade"
                            v-model="quantidade"
                            v-bind="quantity"
                            class="form-control text-right"
                            @input.native="$v.quantidade.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="!temRateio">
                    <b-form-group
                        :state="$v.valorUnitario.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label class="required" for="valorUnitario">
                            Valor Unitário
                        </label>
                        <money
                            id="valorUnitario"
                            v-model="valorUnitario"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorUnitario.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    :disabled="$v.$invalid"
                >
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        acao: {
            type: String
        },

        opcoes: {
            type: Object
        },

        itemAtualizar: {
            type: Object,
        },
    },

    data() {
        return {
            produto: null,
            natureza: null,
            unidade: null,
            quantidade: 0,
            valorUnitario: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            quantity: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        limparVariaveis() {
            this.produto = null  
            this.natureza = null  
            this.unidade = null  
            this.quantidade = 0  
            this.valorUnitario = 0 
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        fecharModal() {
            this.$emit('fechar')
            this.limparVariaveis()
        },

        confirmarSalvar() {
            let produto = this.opcoes.produtosRm.find(x => x.idPrd == this.produto)  
            let natureza = this.opcoes.naturezasRm.find(x => x.codTB1FAT == this.natureza)
            let unidade = this.opcoes.unidadesRm.find(x => x.codUnd == this.unidade)
            
            let itemDto = {
                produto: produto,
                natureza: natureza,
                unidade: unidade,
                quantidade: this.quantidade,
                valorUnitario: this.valorUnitario
            } 

            this.$swal({
                title: 'Item',
                html: `Confirma a ${this.acao == 'INSERIR' ? 'inserção' : 'atualização'} do item<br/><b>${itemDto.produto.nome}<br/>${itemDto.natureza.descricao}<br/>${itemDto.unidade.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar(itemDto)
                }
            })
        },

        salvar(itemDto) {
            if (this.acao == 'INSERIR') {
                this.$emit('inserirItem', itemDto)
            } else {
                itemDto.despesaItemId = this.itemAtualizar.despesaItemId
                this.$emit('atualizarItem', itemDto)
            }
            this.limparVariaveis()
        },

        preencherForm() {
            this.produto = this.itemAtualizar.idPrd
            this.natureza = this.itemAtualizar.codNatureza
            this.unidade = this.itemAtualizar.codUnidade
            this.quantidade = this.itemAtualizar.quantidade
            this.valorUnitario = this.itemAtualizar.valorUnitario
        }
    },

    watch: {
        itemAtualizar() {
            if (this.mostrarModal 
                && this.acao == 'ATUALIZAR' 
                && this.itemAtualizar != null) 
            {
                this.preencherForm()
            } 
        },

        mostrarModal() {
            if (this.mostrarModal
                && this.acao == 'INSERIR' 
            ) {
                this.unidade = 'UN'
            }
        }
    },

    computed: {
        temRateio() {
            return this.acao == 'ATUALIZAR' 
                && this.itemAtualizar != null 
                && this.itemAtualizar.rateios.length != 0
        }
    },

    validations: {
        produto: {
            required
        },

        natureza: {
            required
        },

        unidade: {
            required
        },

        quantidade: {
            required,
            minValue: minValue(0.01)
        },
        valorUnitario: {
            required,
            minValue: minValue(0.01)
        }
    },

    components: {
        ModelListSelect
    }
}
</script>